__turbopack_context__.v({
  "actions": "MessageAttachment-module__7YMVba__actions",
  "body": "MessageAttachment-module__7YMVba__body",
  "fileCard": "MessageAttachment-module__7YMVba__fileCard",
  "fileRow": "MessageAttachment-module__7YMVba__fileRow",
  "filename": "MessageAttachment-module__7YMVba__filename",
  "iconButton": "MessageAttachment-module__7YMVba__iconButton",
  "iconWrap": "MessageAttachment-module__7YMVba__iconWrap",
  "image": "MessageAttachment-module__7YMVba__image",
  "imageLink": "MessageAttachment-module__7YMVba__imageLink",
  "meta": "MessageAttachment-module__7YMVba__meta",
  "pdfPreview": "MessageAttachment-module__7YMVba__pdfPreview",
  "textPreview": "MessageAttachment-module__7YMVba__textPreview",
});
